
import styled from 'styled-components';

const Button = styled.button`
    // width: 36px;
    // height: 36px;
    // border-radius: 18px;
    right: 0;
    border: 0px;
    z-index: 1;
    background-color: ${props => props.active ? "#F0F3F5" : "transparent"};
    -webkit-transition: background-color 500ms linear;
    -ms-transition: background-color 500ms linear;
    transition: background-color 500ms linear;
    &:active {
        background-color: #F0F3F5;
    }
    &:focus {
        outline: 0px;
    }
    // &:hover {
    //     color: red;
    // }
`

export default Button;